export default __webpack_public_path__ + "static/media/school-admin.8fe2fdfb.jpg";